import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips"
}
const _hoisted_3 = { style: {"width":"420px","display":"grid","grid-template-columns":"repeat(3, 1fr)","gap":"18px"} }
const _hoisted_4 = ["src"]

import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-8',
  setup(__props) {

const { curItem } = useDetailCmpt({});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(15, (i) => {
        return _createElementVNode("img", {
          key: i,
          src: `https://cdn.yxvzb.com/WEB/SaaS/bi-v3/images/hot/${i}.png`,
          style: {"width":"100%"}
        }, null, 8, _hoisted_4)
      }), 64))
    ])
  ]))
}
}

})